import { createFileRoute } from '@tanstack/react-router';
import { RoutineForm } from '@/components/insights/RoutineForm.tsx';

export const Route = createFileRoute('/_app/insights/routines/$id/edit')({
  staticData: { orgScope: 'none' },
  component: EditInsightRoutinePage,
});

function EditInsightRoutinePage() {
  const { id } = Route.useParams();

  return <RoutineForm routineId={id} />;
}
